(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
;((win) => {
  const COUNTDOWN_CLASS = 'countdown-timer';

  function initAllCountdowns() {
    document.querySelectorAll(`.${COUNTDOWN_CLASS}[data-initialized="false"]`).forEach(el => {
      startCountdown(el);
    });
  }

  function startCountdown(el) {
    const wrapper   = el.closest('.countdown-wrapper');
    const endDateStr = wrapper.getAttribute('data-end-date')?.trim();
    const style      = wrapper.getAttribute('data-style') || 'simple';

    if (!endDateStr) {
      el.innerHTML = 'No date set';
      el.setAttribute('data-initialized', 'true');
      return;
    }

    const target = Date.parse(endDateStr);
    if (isNaN(target)) {
      el.innerHTML = 'Invalid date';
      el.setAttribute('data-initialized', 'true');
      return;
    }

    let timerId = null;

    const update = () => {
      const now      = Date.now();
      const distance = target - now;

      if (distance <= 0) {
        // AUTO-HIDE THE ENTIRE SECTION
        wrapper.style.display = 'none';
        clearInterval(timerId);
        return;
      }

      const days    = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (style === 'simple') {
        el.innerHTML = `${days}d ${hours}h ${minutes}m ${seconds}s`;
      } else {
        el.innerHTML = `
          <span>${days}<small>d</small></span>
          <span>${hours}<small>h</small></span>
          <span>${minutes}<small>m</small></span>
          <span>${seconds}<small>s</small></span>
        `.trim();
      }
    };

    update();
    timerId = setInterval(update, 1000);
    el.setAttribute('data-initialized', 'true');
  }

  win.addEventListener('DOMContentLoaded', initAllCountdowns);
  win.addEventListener('shopify:section:load', initAllCountdowns);
  win.addEventListener('shopify:section:select', initAllCountdowns);
  initAllCountdowns();
})(window);

  } catch(e) { console.error(e); }
})();
})();
